module.exports = __webpack_public_path__ + "static/iphone-frame-004b5b816cabe1f7d3ec1bac1aac5f4b.png";